import React from 'react'
import SideMenu, {menuItems} from '../../components/SideMenu/SideMenu'

import { useState } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

const VelocityGadget = () => {
    const [inactive, setInactive] = useState(false);

    return (
      <>
            <div style={{marginTop :  "30px"}} >

           <SideMenu
            onCollapse={(inactive) => {
              //console.log(inactive);
              setInactive(inactive);
            }}
          />
  
          <div className={`container ${inactive ? "inactive" : ""}`}>
            {/* improvememt, not recorded in video, its just looping through menuItems
            instead of hard coding all the routes */}
            {menuItems.map((menu, index) => (
              <>
                <Route key={menu.name} exact={menu.exact} path={menu.to}>
                <p>Scrum team health</p> 
                <h3>Velocity Gadget</h3>

                <ul>
                  <li>Velocity monitoring Chart shows statistics of completed sprints from one Scrum board defined in gadget settings. Sprint statistics is configurable and can include the following metrics:

                      <ul>
                          <li>Initial commitment</li>
                          <li>Final commitment</li>
                          <li>Added work</li>
                          <li>Completed work (Velocity)</li>
                          <li>Percentage of completed work according to Final commitment</li>
                          <li>Story point closed in other sprint</li>
                          <li>Story point moved to next sprint</li>
                      </ul>
                  </li>
               </ul>
               <p> By default Completed work is Issues with status Done, but it can be customized by changing the Issue status type from the project workflow list that displays after selecting the Project </p>
               <img style={{ margin:"10px" , width:"55%" ,height:"80%"}} src="./assets/velocityForm.png" alt="img1" width="90%" height="100%"/>
              {/*  <img style={{ margin:"10px" , width:"40%"  }} src="./assets/velocityResult.jpeg" alt="img1" width="100%" height="90%"/>*/}


            <p>result :</p>
            <img style={{ margin:"10px" , width:"55%"  }} src="./assets/velocityResult.jpeg" alt="img1" width="90%" height="100%"/>

              <p>
               <a href="https://www.youtube.com/watch?v=jETHQf9LL6A" target="_blank"> See demo video </a>
               </p>

               

               
               






                 

  
                </Route>
                {menu.subMenus && menu.subMenus.length > 0
                  ? menu.subMenus.map((subMenu, i) => (
                      <Route key={subMenu.name} path={subMenu.to}>
                        <h1>{subMenu.name}</h1>
                      </Route>
                    ))
                  : null}
              </>
            ))}
             
  
            {/* <Switch>
              <Route exact path={"/"}>
                <Dashboard />
              </Route>
              <Route exact path={"/content"}>
                <Content />
              </Route>
              <Route path={"/content/courses"}>
                <Courses />
              </Route>
              <Route path={"/content/videos"}>
                <Videos />
              </Route>
              <Route path={"/design"}>
                <Design />
              </Route>
              <Route exact path={"/content-2"}>
                <Content2 />
              </Route>
              <Route path={"/content-2/courses"}>
                <Courses2 />
              </Route>
              <Route path={"/content-2/videos"}>
                <Videos2 />
              </Route>
              <Route path={"/design-2"}>
                <Design2 />
              </Route>
            </Switch> */}
           
          </div>
          </div>
          
      </>
      
    )
  }
  

export default VelocityGadget
